<div *ngIf="auth && auth.user">
  <div class="search-form">
    <button mat-raised-button color="primary" (click)="search()" class="report-btn"> <mat-icon>search</mat-icon> </button>
    <button mat-raised-button color="primary" (click)="createNew()" class="report-btn"> <mat-icon>save</mat-icon> Create New </button>
  </div>
  <div *ngIf="dataSource">
    <table mat-table [dataSource]="dataSource">
      <ng-container matColumnDef="sourceId">
        <th mat-header-cell *matHeaderCellDef> ID </th>
        <td mat-cell *matCellDef="let element" class="truncate-text"> {{element.sourceId}} </td>
      </ng-container>
      <ng-container matColumnDef="langId">
        <th mat-header-cell *matHeaderCellDef> Language ID </th>
        <td mat-cell *matCellDef="let element" class="truncate-text"> {{element.langId}} </td>
      </ng-container>
      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef> Description </th>
        <td mat-cell *matCellDef="let element" class="truncate-text"> {{element.description}} </td>
      </ng-container>
      <ng-container matColumnDef="langGroup">
        <th mat-header-cell *matHeaderCellDef> Language Group </th>
        <td mat-cell *matCellDef="let element"> {{element.langGroup}} </td>
      </ng-container>
      <ng-container matColumnDef="inactive">
        <th mat-header-cell *matHeaderCellDef> Is Inactive </th>
        <td mat-cell *matCellDef="let element"><mat-icon *ngIf="element.inactive">check</mat-icon></td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"  (click)="showDetails(row)"></tr>
    </table>
  </div>
</div>